 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import HALFTITLE from '@/components/halftitle'
 import ALSO from '@/components/also'
 import TITLE from '@/components/title'
 import COPYRIGHT from '@/components/copyright'
 import EPUB_9781605096230_3 from '@/components/Epub_9781605096230_3'
 import EPUB_9781605096230_4 from '@/components/Epub_9781605096230_4'
 import EPUB_9781605096230_5 from '@/components/Epub_9781605096230_5'
 import EPUB_9781605096230_6 from '@/components/Epub_9781605096230_6'
 import EPUB_9781605096230_7 from '@/components/Epub_9781605096230_7'
 import EPUB_9781605096230_8 from '@/components/Epub_9781605096230_8'
 import EPUB_9781605096230_9 from '@/components/Epub_9781605096230_9'
 import EPUB_9781605096230_10 from '@/components/Epub_9781605096230_10'
 import EPUB_9781605096230_11 from '@/components/Epub_9781605096230_11'
 import EPUB_9781605096230_11A from '@/components/Epub_9781605096230_11a'
 import EPUB_9781605096230_11B from '@/components/Epub_9781605096230_11b'
 import INDEX from '@/components/index'
 import ABOUT from '@/components/about'
 import PUBLISHER from '@/components/publisher'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/halftitle",
 			"name" : "halftitle",
 			"component" : HALFTITLE
 		},
 		{
 			"path" : "/also",
 			"name" : "also",
 			"component" : ALSO
 		},
 		{
 			"path" : "/title",
 			"name" : "title",
 			"component" : TITLE
 		},
 		{
 			"path" : "/copyright",
 			"name" : "copyright",
 			"component" : COPYRIGHT
 		},
 		{
 			"path" : "/Epub_9781605096230_3",
 			"name" : "Epub_9781605096230_3",
 			"component" : EPUB_9781605096230_3
 		},
 		{
 			"path" : "/Epub_9781605096230_4",
 			"name" : "Epub_9781605096230_4",
 			"component" : EPUB_9781605096230_4
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js